module.exports = __webpack_public_path__ + "media/images/goldmembers-17f75e766b9e7749679148759c67d447.png";